import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 身分證件上傳
 */
const IdDocUploadPostBack = [
    'POST',
    RouteUrlList.API_IdDocUploadPostBack.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: ''
    }
];
export default IdDocUploadPostBack;
